import { ContentfulPageProps } from "../../templates/content-page";
import ArticleHeader from "../article-header";
import { LargeHeader } from "./LargeHeader";
import { LargeHeaderWithImage } from "./LargeHeaderWithImage";
import { SimplePageHeader } from "./SimplePageHeader";
import { Box, Heading } from "@vinomofo/components";
import styled from "styled-components";

const VisuallyHidden = styled(Box)`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const PageHeader = ({
  title,
  subTitle,
  headingLayout,
  heroImage,
  author,
  readingTime,
  publishedDate,
  profileImage,
  pagePath,
}: Omit<ContentfulPageProps, "pageSections">): JSX.Element => {
  if (pagePath === "/" || pagePath === "") {
    return (
      <VisuallyHidden>
        <Heading variant="xl" as="h1">
          {"Online wine store."}
        </Heading>
      </VisuallyHidden>
    );
  }

  if (headingLayout === "No heading") {
    return null;
  }

  switch (headingLayout) {
    case "Simple heading":
      return <SimplePageHeader title={title} />;
    case "Large hero":
      return heroImage ? (
        <LargeHeaderWithImage
          title={title}
          subTitle={subTitle}
          heroImage={heroImage}
        />
      ) : (
        <LargeHeader title={title} subTitle={subTitle} />
      );
    case "Article heading":
      return (
        <ArticleHeader
          title={title}
          author={{
            name: author,
            image: profileImage?.url,
          }}
          readingTime={readingTime}
          publishDate={publishedDate}
          image={heroImage?.url}
        />
      );
  }
};
